import React from 'react';
import ZonesInterestCreate from './create';
import ZonesInterestList from './list';
import ZonesInterestEdit from './edit';

const ZonesInterestTitle = ({ record }) => {
    return <span>Editando la zona de interest {record ? `${record.name}` : ''}</span>;
};

export {ZonesInterestCreate, ZonesInterestList, ZonesInterestTitle, ZonesInterestEdit};